module.exports = {
  colors: {
    current: "currentColor",
    "Primary-900": "#1F598A",
    "Primary-800": "#2878AC",
    "Primary-700": "#2C89C0",
    "Primary-600": "#339CD4",
    "Primary-500": "#39ABE2",
    "Primary-400": "#48B6E6",
    "Primary-300": "#61C3E9",
    "Primary-200": "#c393cc",
    "Primary-100": "#f0e5f2",
    "Primary-50": "#EAF6FC",
    "Secondary-300": "#F16E7E",
    "Secondary-200": "#F798A3",
    "Secondary-100": "#F16E7E",
    "Secondary-50": "#FFEBF1",
    SP2: "#FFA000",
    SP1: "#FFE600",
    SP3: "#ED1849",
    SP4: "#DB3532",
    SP5: "#FD4839",
    SP6: "#E5003D",
    SP7: "#E2F5FB",
    SP8: "#C3003E",

    Body: "#232323",
    "Body-Inactive": "#595959",
    "Body-Disabled": "#C9C9C9",
    White: "#ffffff",
    Black: "#000000",
    Green: "#25D816",
    Highlight: "#ffe500",
    Transparent: "rgba(255, 255, 255, 0)",
    Opacity9: "rgba(0, 0, 0, 0.9)",
    Opacity5: "rgba(0, 0, 0, 0.5)",
    // Activity Category Colours
    "Splash-Zone": "#2C89C0",
    "Power-Teams": "#F15846",
    "Super-Sports": "#7C62AB",
    "Globe-Trotters": "#5BA540",
    "Creative-Inventors": "#F1696C",
    "Brain-Boosters": "#D68100",
    "Zen-Masters": "#FAE80B",

    // Tear Colours
    "Dark-Theme-Tear-Primary": "#E5003D",
    "Dark-Theme-Tear-Secondary": "#3DCFFF",
    "Light-Theme-Tear-Primary": "#E5003D",
    "Light-Theme-Tear-Secondary": "#3DCFFF",
    "Alternative-Theme-Tear-Primary": "#E5003D",
    "Alternative-Theme-Tear-Secondary": "#3DCFFF",
    "White-Theme-Tear-Primary": "#E5003D",
    "White-Theme-Tear-Secondary": "#3DCFFF",
    // Hero Gradients
    "Homepage-Hero/Gradient-Start": "#E5003D",
    "Homepage-Hero/Gradient-End": "transparent",
    "Secondary-Hero/Gradient-Start": "#401d6e",
    "Secondary-Hero/Gradient-End": "#7c3092",
    // Background Texture Colours
    "Background-Texture-Primary": "#E2F5FB",
    "Primary-Button-Text": "#FFFFFF",

    "sherpa-blue-50": "#E2F5FB",
    "sherpa-blue-100": "#B6E5F6",
    "sherpa-blue-150": "#B8D5EF",
    "sherpa-blue-200": "#89D4F0",
    "sherpa-blue-300": "#61C3E9",
    "sherpa-blue-400": "#48B6E6",
    "sherpa-blue-500": "#39ABE2",
    "sherpa-blue-600": "#339CD4",
    "sherpa-blue-700": "#2C89C0",
    "sherpa-blue-800": "#2878AC",
    "sherpa-blue-850": "#236E9A",
    "sherpa-blue-900": "#1F598A",

    "sherpa-red-50": "#FFEBF1",
    "sherpa-red-100": "#FFCDD8",
    "sherpa-red-200": "#F798A3",
    "sherpa-red-300": "#F16E7E",
    "sherpa-red-400": "#ED385B",
    "sherpa-red-500": "#E71441",
    "sherpa-red-525": "#E82150",
    "sherpa-red-550": "#E5003D",
    "sherpa-red-600": "#D70B40",
    "sherpa-red-700": "#C3003E",
    "sherpa-red-800": "#B0003C",
    "sherpa-red-850": "#A30034",
    "sherpa-red-900": "#8E0039",
    "sherpa-red-950": "#85002A",

    "sherpa-yellow-100": "#FFFAD6",
    "sherpa-yellow-300": "#FFC527",
    "sherpa-yellow-400": "#F0B000",

    "sherpa-green-500": "#5BA540",
    "sherpa-orange-600": "#D68100",

    // SK-specific component colors
    "sk-button-primary-bg": "#FFFFFF",
    "sk-button-primary-text": "#1F598A",
    "sk-button-primary-hover-bg": "#B8D5EF",
    "sk-button-primary-hover-text": "#1F598A",
    "sk-button-secondary-bg": "#2C89C0",
    "sk-button-secondary-text": "#000000",
    "sk-button-secondary-hover-bg": "#236E9A",
    "sk-button-secondary-hover-text": "#FFFFFF",
    "sk-testimonial-selected-dot": "#E5003D",
    "sk-testimonial-unselected-dot": "#FF5784",
    "sk-related-article-highlight-bg": "#B8D5EF",
    "sk-related-article-tag-bg": "#E5003D",

    "sherpa-red-main": "#E5003D",
    "sherpa-blue-main": "#3DCFFF",
    "sherpa-body": "#232323",
    "sherpa-yellow": "#FFE600",
    "sherpa-white": "#FFFFFF",
    "sherpa-black": "#000000",
    "sherpa-gray": "#595959",
  },
  fontSize: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "4rem",
  },
  fontFamily: { primary: "Avenir", secondary: "Chaloops" },
  boxShadow: {
    Inner: "inset 0px 2px 4px 0px rgba(0,34,66,0.2)",
    Sm: "0px 1px 2px 0px rgba(0,34,66,0.05)",
    Default: "0px 1px 2px 0px rgba(0,34,66,0.06), 0px 1px 3px 0px rgba(0,34,66,0.1)",
    Md: "0px 2px 4px -1px rgba(0,34,66,0.06), 0px 4px 6px -1px rgba(0,34,66,0.1)",
    Lg: "0px 4px 6px -2px rgba(0,34,66,0.05), 0px 10px 15px -3px rgba(0,34,66,0.1)",
    Xl: "0px 10px 10px -5px rgba(0,34,66,0.04), 0px 20px 25px -5px rgba(0,34,66,0.1)",
    "2xl": "0px 25px 50px -12px rgba(0,0,0,0.3)",
  },
  borderRadius: {
    none: "0",
    xs: "0.125rem",
    sm: "0.13320313394069672rem",
    default: "0.18736979365348816rem",
    lg: "0.1875rem",
    xl: "0.25rem",
    "2xl": "0.3125rem",
    "3xl": "0.3747395873069763rem",
    "4xl": "0.375rem",
    "5xl": "0.5rem",
    "6xl": "0.625rem",
    "7xl": "0.6660156846046448rem",
    "8xl": "0.7305389046669006rem",
    full: "9999px",
  },
  screens: {
    sm: "672px" /* 640 ith 16px gutter */,
    md: "800px" /* 768 with 16px gutter */,
    lg: "1056px" /* 1024 with 16px gutter */,
    xl: "1440px" /* 1280 with 80px gutter */,
    "2xl": "1600px" /*1440 with 80px gutter */,
    "3xl": "1920px" /* 1536 with 192px gutter */,
  },
  container: {
    padding: {
      DEFAULT: "16px",
      xl: "80px",
      "2xl": "192px",
    },
  },
  extend: {
    transitionDelay: {
      400: "400ms",
      600: "600ms",
      800: "800ms",
      900: "900ms",
      1100: "1100ms",
      1200: "1200ms",
      1300: "1300ms",
    },
  },
  variants: {
    fill: ["group-hover", "hover", "focus"],
    textColor: ["responsive", "hover", "focus", "group-hover"],
    scrollbar: ["rounded"],
    boxShadow: ["responsive", "hover", "focus"],
    extend: {
      gridColumnEnd: ["last"],
    },
  },
  safeList: [
    "text-White",
    "text-Highlight",
    "current",
    "fill-current",
    "rotate-180",
    "group-hover:rotate-180",
    "visible",
    "invisible",
    {
      pattern: /text-(Primary|Secondary)-(50|100|200|300|400|500|600|700|800|900)/,
      variants: ["hover", "group-hover"],
    },
    {
      pattern: /fill-(Primary|Secondary)-(50|100|200|300|400|500|600|700|800|900)/,
      variants: ["hover", "group-hover"],
    },
  ],
};
